import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './mandantenverwaltung-einstellungen.reducer';
import {PandemieMandantOptions} from '../../../clients/pandemie';

export const getModuleState = createFeatureSelector<ModuleState>('MandantenverwaltungEinstellungenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getStammConfig = createSelector(getPageState, (state: PageState) => state.stammConfig);
export const getLizenzConfig = createSelector(getPageState, (state: PageState) => state.lizenzConfig);
export const getMandantInfo = createSelector(getPageState, (state: PageState) => state.mandantId);
export const getVorlagenConfig = createSelector(getPageState, (state: PageState) => state.vorlagenConfig);
export const getVeranstaltungenConfig = createSelector(getPageState, (state: PageState) => state.veranstaltungenConfig);
export const getPandemieConfig = createSelector(getPageState, (state: PageState): PandemieMandantOptions => state.pandemieConfig);
export const getIncidentAnzeigeConfig = createSelector(getPageState, (state: PageState) => state.incidentAnzeigeConfig);

export const getMandantConfigLaden = createSelector(getPageState, (state: PageState) => state.mandantConfigLaden);
export const getMandantConfigFehler = createSelector(getPageState, (state: PageState) => state.mandantConfigFehler);

export const getMandantLogo = createSelector(getPageState, (state: PageState) => state.mandantLogo);
export const getMandantLogoLaden = createSelector(getPageState, (state: PageState) => state.mandantLogoLaden);
export const getMandantLogoFehler = createSelector(getPageState, (state: PageState) => state.mandantLogoFehler);
